<template>
  <b-container fluid style="height: calc(100vh - 100px); overflow:auto;">
    <b-row>
      <b-col>
        <h6>Select Questionnaire, Policy or Communication :</h6>
      </b-col>
      <b-col cols="6">
        <b-form-group class="text-left my-2">
          <!-- <label>:</label> -->
          <v-select
            searchable
            clearable
            label="text"
            :options="availableDDqs"
            v-model="selectedDDq"
            @input="onSelectDDq"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-2x">
      <b-col cols="3">
        <b-card title="Total">
          <!-- <h1>{{overallValues[0]}}</h1> -->
          <b-card-text style="font-size:50px;" class="text-primary text-center">
            <number
              ref="number1"
              :from="0"
              :to="overallValues[0]"
              :duration="1"
              :delay="0"
              easing="Power1.easeOut"
            />
          </b-card-text>
        </b-card>
      </b-col>
      <b-col cols="3">
        <b-card title="Pending">
          <!-- <h1>{{overallValues[0]}}</h1> -->
          <b-card-text style="font-size:50px;" class="text-primary text-center">
            <number
              ref="number1"
              :from="0"
              :to="overallValues[1]"
              :duration="1"
              :delay="0"
              easing="Power1.easeOut"
            />
          </b-card-text>
        </b-card>
      </b-col>
      <b-col cols="3">
        <b-card title="Completed">
          <b-card-text style="font-size:50px;" class="text-primary text-center">
            <number
              ref="number1"
              :from="0"
              :to="overallValues[2]"
              :duration="1"
              :delay="0"
              easing="Power1.easeOut"
            />
          </b-card-text>
        </b-card>
      </b-col>
      <b-col cols="3">
        <b-card title="Not Started">
          <b-card-text style="font-size:50px;" class="text-primary text-center">
            <number
              ref="number1"
              :from="0"
              :to="overallValues[3]"
              :duration="1"
              :delay="0"
              easing="Power1.easeOut"
            />
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>

    <b-tabs content-class="mt-3" align="right">
      <b-tab title="Overview" active>
        <b-button
          class="float-right mx-3"
          variant="outline-primary"
          size="sm"
          @click="configModalShow = !configModalShow"
        >
          <i class="fa fa-cogs" aria-hidden="true"></i>
        </b-button>
        <b-container fluid v-if="!isLoading">
          <b-row v-for="(sec, sIndex) in chartConfig.totalSections" :key="sIndex" class="my-2">
            <b-container v-if="showSectionTitle" fluid class="text-left">
              <h3>{{sec.title}}</h3>
            </b-container>
            <b-col :cols="selectedLayout.val" v-for="(opt, index) in sec.section" :key="index">
              <b-row>
                <b-col>
                  <b-card class="my-4" header-tag="header" footer-tag="footer">
                    <template v-if="showQuestionTitle" v-slot:header>
                      <h6 class="mb-0">{{opt.data[opt.data.length-1].shortTitle}}</h6>
                    </template>

                    <!-- card body -->
                    <b-card-body>
                      <b-row>
                        <b-col :cols="selectedLayout.val == 12 ? 6 : 12">
                          <DashboardStatsComponent :chartOptions="opt.data[opt.data.length-1]" />
                        </b-col>
                        <b-col cols="6">
                          <b-table
                            v-if="selectedLayout.val == 12"
                            :items="opt.data"
                            :fields="fields"
                          ></b-table>
                        </b-col>
                      </b-row>
                    </b-card-body>

                    <template v-slot:footer>
                      <b-dropdown
                        id="dropdown-1"
                        :text="'Chart Type '+ opt.data[opt.data.length-1].chart.type "
                        class="m-md-2 float-left text-capitalize"
                      >
                        <b-dropdown-item
                          @click="onSelectChart('Bar', sIndex, index, opt.data[opt.data.length-1])"
                        >Bar</b-dropdown-item>
                        <b-dropdown-item
                          @click="onSelectChart('Line', sIndex, index, opt.data[opt.data.length-1])"
                        >Line</b-dropdown-item>
                        <b-dropdown-item
                          @click="onSelectChart('Area', sIndex,index, opt.data[opt.data.length-1])"
                        >Area</b-dropdown-item>
                        <b-dropdown-item
                          @click="onSelectChart('Pie', sIndex,index, opt.data[opt.data.length-1])"
                        >Pie</b-dropdown-item>
                        <b-dropdown-item
                          @click="onSelectChart('Scatter', sIndex,index, opt.data[opt.data.length-1])"
                        >Scatter</b-dropdown-item>
                        <b-dropdown-item
                          @click="onSelectChart('Pyramid', sIndex,index, opt.data[opt.data.length-1])"
                        >Pyramid</b-dropdown-item>
                        <b-dropdown-item
                          @click="onSelectChart('Funnel', sIndex,index, opt.data[opt.data.length-1])"
                        >Funnel</b-dropdown-item>
                        <b-dropdown-item
                          @click="onSelectChart('Columnpyramid', sIndex, index, opt.data[opt.data.length-1])"
                        >Columnpyramid</b-dropdown-item>
                      </b-dropdown>
                    </template>
                  </b-card>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>

        <div class="text-center" v-else>
          <b-spinner variant="primary"></b-spinner>
        </div>
      </b-tab>
      <b-tab title="2019">
        <p>I'm the second tab</p>
      </b-tab>
      <b-tab title="2020">
        <p>I'm the second tab</p>
      </b-tab>
    </b-tabs>
    <b-modal v-model="configModalShow" title="Select Configs">
      <b-form-checkbox v-model="showSectionTitle">Show Section Title</b-form-checkbox>
      <b-form-checkbox v-model="showQuestionTitle">Show Question Title</b-form-checkbox>
      <b-dropdown id="dropdown-1" :text="'Layout ' + selectedLayout.key" class="m-md-2 float-right">
        <b-dropdown-item
          v-for="layout in layoutOptions"
          :key="layout.key"
          @click="onSelectLayout(layout)"
        >{{layout.key}}</b-dropdown-item>
      </b-dropdown>
    </b-modal>
  </b-container>
</template>
<script>
import axios from "axios";
import DashboardStatsComponent from "../components/stats/dashboardStatsComponent.vue";
import config from "./../configs/config";
import { HTTP } from "../utils/HTTP";
export default {
  name: "DashboardStats",
  components: {
    DashboardStatsComponent
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      configModalShow: false,
      showSectionTitle: true,
      showQuestionTitle: true,
      chartConfig: {
        totalSections: []
      },
      overallValues: [100, 15, 30, 20],
      max: 100,
      isLoading: false,
      layoutOptions: [
        { val: 12, key: 1 },
        { val: 6, key: 2 },
        { val: 4, key: 3 },
        { val: 3, key: 4 }
      ],
      selectedDDq: "Anti Bribery Corruption",
      availableDDqs: [{ text: "Anti Bribery Corruption", value: "1" }],
      overallStats: {},
      selectedLayout: { val: 4, key: 3 },
      selectedChartType: "Bar",
      fields: [
        {
          key: "name",
          label: "Options"
        },
        {
          key: "y",
          label: "Count"
        }
      ]
    };
  },

  mounted() {
    this.getDdqstat();
    this.getSingleDdq();
  },

  methods: {
    async getDdqstat() {
      try {
        let result = await axios({
          url: config.API_URL + "chart/getddqstat",
          method: "POST",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken")
          },
          data: {
            companyId: this.$route.params.id
          }
        });

        if (result.data.data) {
          this.max = result.data.data.totalTp;
          this.overallValues = [
            result.data.data.tpWithDDQ,
            result.data.data.tpWithDDQInProgress,
            result.data.data.tpWithDDQCompleted,
            result.data.data.tpWithDDQNotStarted
          ];
        }
      } catch (error) {
        // console.log("error---- in getting form languages", error);
      }
    },

    onSelectDDq(val) {},

    async getSingleDdq() {
      this.isLoading = true;
      try {
        let result = await axios({
          url: config.API_URL + "chart/getddqquestionstat",
          method: "POST",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken")
          },
          data: {
            companyId: this.$route.params.id
            //companyId: 758
          }
        });
        // // console.log("result", result.data);

        if (
          result.data.response.sections &&
          result.data.response.sections.length
        ) {
          result.data.response.sections.map((section, index) => {
            // // console.log("seccc", section[index].sectionTitle)
            let dd = {
              title: section[index].sectionTitle,
              section
            };
            this.chartConfig.totalSections.push(dd);
          });
          this.newDataSet();
          // // console.log("this.chartConfig.totalQuestions", this.chartConfig);
        }
      } catch (error) {
        // console.log("error---- in getting form languages", error);
      } finally {
        this.isLoading = false;
      }
    },

    newDataSet() {
      this.chartConfig.totalSections.map(ss => {
        // // console.log("ss", ss)
        ss.section.map(q => {
          // // console.log("q", q.data);
          let i = 0;
          let tempSeries = [];
          for (i; i < q.data.length; i++) {
            // // console.log("q.data", q.data[i])
            tempSeries.push(q.data[i]);
          }
          // // console.log("tempSeries", tempSeries)
          let names = [];
          q.data.map(d => {
            names.push(d.name);
          });

          let data = {
            shortTitle: q.questionAbbreviation,
            sectionTitle: q.sectionTitle,
            chart: {
              polar: false,
              type: q.selectedChart
            },
            title: {
              text: q.questionTitle
            },
            xAxis: {
              categories: names
            },
            yAxis: {
              min: 0,
              title: {
                text: ""
              }
            },
            legend: {
              reversed: true
            },
            plotOptions: {
              series: {
                stacking: "normal"
              }
            },
            series: [
              {
                name: "",
                data: tempSeries
              }
            ]
          };

          q.data.push(data);
        });
      });
      // // console.log("this", this.chartConfig);
    },

    onSelectLayout(e) {
      // // console.log("e", e)
      this.selectedLayout = e;
      this.toggleRender();
    },

    onSelectChart(type, sIndex, index, q) {
      // // console.log("type, index", q);
      let section = this.chartConfig.totalSections[sIndex].section[index].data;
      this.selectedChartType = type;
      section[section.length - 1].chart.type = type.toLowerCase();
      // this.chartConfig = {
      //   ...this.chartConfig,
      //   chart: {
      //     ...this.chartConfig.chart,
      //     type: type.toLowerCase()
      //   }
      // };

      this.toggleRender();
    },

    toggleRender() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 100);
    }
  }
};
</script>